<script setup>
import { ref, computed, onMounted, onBeforeUnmount, defineProps } from "vue";

const props = defineProps({
  text: { type: String, required: true }, // Mensaje del tooltip
  position: { type: String, default: "top" } // Posición: top, bottom, left, right
});

const visible = ref(false);
const tooltipRef = ref(null);

const toggleTooltip = () => {
  visible.value = !visible.value;
};

// Manejar clicks fuera del tooltip
const outsideClickHandler = (event) => {
  if (visible.value && tooltipRef.value && !tooltipRef.value.contains(event.target)) {
    visible.value = false;
  }
};

// Agregar y eliminar evento global de click
onMounted(() => {
  document.addEventListener("click", outsideClickHandler);
});

onBeforeUnmount(() => {
  document.removeEventListener("click", outsideClickHandler);
});

const tooltipPosition = computed(() => {
  return `tooltip-${props.position}`;
});
</script>

<template>
    <div class="tooltip-wrapper" @click.stop="toggleTooltip">
    <button class="tooltip-btn"><span>i</span></button>
        <div 
          class="tooltip-content" 
          :class="[tooltipPosition, {'active':visible}]"
          ref="tooltipRef"
        >
          {{ text }}
        </div>
    </div>
  </template>
  
<style lang="scss" scoped>
@import 'TooltipComponent';
</style>
  
  
  